import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aa7fe1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "alert" }
const _hoisted_4 = { class: "container" }

import Breadcrumb from "@/components/breadcrumb.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'layout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"position":"relative","background":"#f5f7fb"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout, { class: "s5-mt s5-mr layout-content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Breadcrumb)
          ]),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$route.meta?.title), 1),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "alert")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }),
      _renderSlot(_ctx.$slots, "sider")
    ]),
    _: 3
  }))
}
}

})